/* AMCL sections — scroll reveal */
(function () {
  if (window.__amclInit) return;
  window.__amclInit = true;

  const init = () => {
    const els = document.querySelectorAll('.amcl-reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(el => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run cuando el editor de Shopify recarga la sección
  document.addEventListener('shopify:section:load', init);
})();
